
import { Component, Prop, Vue } from 'vue-property-decorator';

@Component({
	name: 'ShuttleTrackerWidget',
})
export default class ShuttleTrackerWidget extends Vue {
	public show: boolean = true;

	@Prop({ type: String, required: true })
	public trackerUrl!: string;

	public hide() {
		this.show = false;
	}
}
